export interface SubReasonListProps {
  name: string;
  subReasonList: SubReason[];
  showComment?: boolean;
  onSelectionChange?: (value: SubReason[]) => void;
}

export interface SubReason {
  label: string;
  value: string;
}
